export default __webpack_public_path__ + "static/media/logosource.ea541fac.svg";